export default "https://d1e6s5z4lzmgxx.cloudfront.net/3cbd492b-c681-4587-ab2f-cab322978701/images/metronome-icon.svg?9bb8edff54f1c5f654940ac123f2c181";